import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { useIntl } from '../../../../../util/reactIntl';
import { caregiverCategories } from '../../../../../util/caregiverSearch';

import css from './FilterKeyword.module.css';

const FilterKeyword = props => {
  const intl = useIntl();
  const { className, rootClassName } = props;
  const rootClass = rootClassName || css.root;
  const classes = classNames(rootClass, className);

  return (
    <div className={classes}>
      <Field name="pub_category">
        {fieldRenderProps => {
          const { input } = fieldRenderProps;

          return (
            <select
              {...input}
              id="keywords-select"
              className={css.customField}
            >
              <option value="">
                {intl.formatMessage({
                  id: 'PageBuilder.SearchCTA.categoryFieldPlaceholder',
                })}
              </option>
              {caregiverCategories.map(category => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          );
        }}
      </Field>
    </div>
  );
};

export default FilterKeyword;
